import React from "react";
import noavatar from "../../../assets/img/noavatar.png";
import { TfiCar } from "react-icons/tfi";
import NoProduct from "../../../components/user/Order/noProduct";

function All({ args, data, getOrderById2, getOrderById }) {
  return (
    <>
      {data.length > 0 ? (
        data
          .sort((a, b) => new Date(a.date) - new Date(b.date))
          .map((item) => (
            <div className="tab_content py-4 mb-4" key={item.id}>
              <div className="px-4">
                <div className="d-flex justify-content-between pb-3">
                  <p className="fs-6 tab_date">
                    Ngày đặt: {item.date.slice(0, 10)}
                  </p>
                  <p className="tab_transport  d-flex align-items-center">
                    <TfiCar className="me-2 t-primary fs-5" />
                    <span className="t-primary fs-24">
                      {item.status === 0 ? (
                        "Waitting"
                      ) : (
                        <>
                          {item.status === 1 ? (
                            "Delivery"
                          ) : (
                            <>
                              {item.status === 2 ? (
                                "Received"
                              ) : (
                                <>{item.status === 3 ? "Cancelled" : ""}</>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </span>
                  </p>
                </div>

                {item.orderDetails.map((p, i) => (
                  <div
                    className="d-flex align-items-center justify-content-between border-top border-bottom py-3 px-4"
                    key={i}
                  >
                    <div className="tab_img w-12">
                      <img
                        src={
                          `${
                            process.env.REACT_APP_URL_IMAGE + p.product.image
                          }` || noavatar
                        }
                        alt="product"
                        width={100}
                        height={100}
                      />
                    </div>

                    <div className="tab_product w-100 d-flex flex-column px-4">
                      <p className="product_name fw-600 fs-24">
                        {p.product.name}
                      </p>
                      <p className="product_category py-1">
                        {p.product.category.name}
                      </p>
                      <p className="product_quantity">x{p.quantity}</p>
                    </div>
                    <div className="product_price w-12 text-end fs-20">
                      {(
                        (p.product.price * (100 - p.product.discount)) /
                        100
                      ).toLocaleString("vi")}
                      &#273;
                    </div>
                  </div>
                ))}

                {item.status === 0 ? (
                  <div className="product_total d-flex align-items-center justify-content-end pt-3 fs-24">
                    <div
                      className="btn_order me-3"
                      onClick={() => getOrderById2(item.id)}
                    >
                      Cancelled
                    </div>
                    <p>
                      Total:{" "}
                      <span className="product_price t-primary fs-20 fw-bold">
                        {(item.totalPrice * 1).toLocaleString("vi")}
                        &#273;
                      </span>
                    </p>
                  </div>
                ) : (
                  <>
                    {item.status === 1 ? (
                      <div className="product_total d-flex align-items-center justify-content-end pt-3 fs-24">
                        <div
                          className="btn_order me-3"
                          onClick={() => getOrderById(item.id)}
                        >
                          Received
                        </div>
                        <p>
                          Total:{" "}
                          <span className="product_price t-primary fs-20 fw-bold">
                            {(item.totalPrice * 1).toLocaleString("vi")}
                            &#273;
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div className="product_total text-end pt-3 fs-24">
                        Total:{" "}
                        <span className="product_price t-primary fs-20 fw-bold">
                          {(item.totalPrice * 1).toLocaleString("vi")}
                          &#273;
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))
      ) : (
        <NoProduct />
      )}
    </>
  );
}

export default All;
